<template>
    <v-expansion-panel v-if="expansionPanel" :value="expansionPanelId" :elevation="elevation">
        <v-expansion-panel-title color="kpmgPrimary-900">
            <slot name="title">{{ title }}</slot>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="py-4">
            <slot name="text">
                <v-list>
                    <slot name="list">
                    </slot>
                </v-list>
            </slot>
        </v-expansion-panel-text>
    </v-expansion-panel>
    <v-card v-else :elevation="elevation">
        <v-card-title>
            <slot name="title">{{ title }}</slot>
        </v-card-title>
        <v-card-subtitle class="text-wrap">
            <slot name="subtitle">{{ subTitle }}</slot>
        </v-card-subtitle>
        <v-card-text>
            <slot name="text">
                <v-list>
                    <slot name="list">
                    </slot>
                </v-list>
            </slot>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
import {defineComponent} from "vue"

export default defineComponent({
    props: {
        title: {
            type: String
        },
        subTitle: {
            type: String
        },
        expansionPanel: {
            type: Boolean,
            default: false
        },
        expansionPanelId: {
            type: String
        },
        elevation: {
            type: Number,
            default: 1
        }
    },
    setup() {
        return {}
    },
})
</script>

<style lang="scss" scoped>
.v-expansion-panel-text::v-deep(.v-expansion-panel-text__wrapper) {
    padding-right: 0 !important;
}
</style>
